export const SIGN_INFO = 'SIGN_INFO'
export const LOGIN_USER = 'LOGIN_USER'
export const SIGN_OUT_USER = 'SIGN_OUT_USER'
export const SET_TYPE = 'SET_TYPE'
export const SET_PAGE = 'SET_PAGE'
export const SET_UPDATE = 'SET_UPDATE'
export const SET_LOADING = 'SET_LOADING'
export const SET_FETCH = 'SET_FETCH'
export const SET_FILTRAGE = 'SET_FILTRAGE'
export const TIME_START = 'TIME_START'
export const TIMEOUT_ID = 'TIMEOUT_ID'

export const FETCH_ACTIVITES = 'FETCH_ACTIVITES'
export const FETCH_OFFRES = 'FETCH_OFFRES'
export const FETCH_FORMULES = 'FETCH_FORMULES'
export const FETCH_ACCESSOIRES = 'FETCH_ACCESSOIRES'
export const FETCH_ARTICLES = 'FETCH_ARTICLES'
export const FETCH_TACHES = 'FETCH_TACHES'
export const FETCH_ROOMS = 'FETCH_ROOMS'
export const FETCH_CODE_PROMOS = 'FETCH_CODE_PROMOS'
export const FETCH_CONFIGURATIONS = 'FETCH_CONFIGURATIONS'

export const SET_SIDEBAR = 'SET_SIDEBAR'
export const SET_TOPBAR = 'SET_TOPBAR'
export const SET_IP_ADDRESS = 'SET_IP_ADDRESS'